<template>
  <v-col class="card pa-0">
    <div class="lu-card-list">
      <div class="lu-scroll pb-2">
        <IuSelect></IuSelect>
        <IuLink></IuLink>
        <IuLegend></IuLegend>
        <IuOpacity></IuOpacity>
        <IuNavi></IuNavi>
      </div>
    </div>
  </v-col>
</template>

<script>
import mixin from "../../../lib/mixin.js";
import IuSelect from "../../../components/pc/IuSelect.vue";
import IuOpacity from "../../../components/pc/IuOpacity.vue";
import IuLink from "../../../components/pc/IuLink.vue";
import IuLegend from "../../../components/pc/IuLegend.vue";
import IuNavi from "../../../components/pc/IuNavi.vue";

export default {
  mixins: [mixin],
  components: {
    IuSelect,
    IuOpacity,
    IuLink,
    IuLegend,
    IuNavi
  },
  computed: {
    /** 表示コンテンツ */
    content: {
      get() {
        return this.$store.state.app.content;
      }
    },
    /**
     * リクエストパラメータ
     */
    reqParam: {
      get() {
        return {
          towns: this.$store.state.map.towns,
          townsAcqTime: this.$store.state.map.townsAcqTime,
          zoom: this.$store.state.map.zoom
        };
      }
    },

    /**
     * 表示範囲の浸水想定区域データ
     */
    inundations: {
      get() {
        return {
          townsAcqTime: this.$store.state.inundation.inundationParam
            .townsAcqTime,
          inundations: this.$store.state.inundation.inundations,
          selectedInundationParam: this.$store.state.inundation
            .selectedInundationParam
        };
      }
    },
    /**
     * 表示範囲のハザードマップ一覧
     */
    hazardMap: {
      get() {
        return {
          hazardMap: this.$store.state.inundation.hazardMap
        };
      }
    }
  },
  mounted() {
    /** 表示コンテンツのセット */
    this.$store.commit("app/setContent", "Inundation");
  },
  watch: {
    reqParam() {
      if (
        this.reqParam.zoom >= 12 &&
        this.reqParam.townsAcqTime != this.inundations.townsAcqTime
      ) {
        this.getInundations();
      }
    }
  },
  methods: {
    /**
     * 表示範囲の浸水想定区域データ取得
     */
    getInundations() {
      setTimeout(() => {
        this.$store.dispatch("inundation/getInundations", {
          townsAcqTime: this.reqParam.townsAcqTime,
          towns: this.reqParam.towns
        });
      }, 500);
    }
  }
};
</script>

<style lang="scss" scoped>
.card {
  padding: 16px;
  height: 100%;

  .lu-card-list {
    position: relative;
    height: 100%;
  }
  .lu-scroll {
    position: absolute;
    height: 100%;
    overflow: auto;
    top: 0px;
    left: 0px;
    right: 0px;
    bottom: 0px;
    & > :not(:first-child) {
      margin-top: 4px;
    }
  }
}
</style>
